import { Button, Tooltip, useTheme } from "@mui/material";
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { getOrgTokens } from "../../theme/style/organizationPalette";

const UploadBOMButton = ({ label = "Upload BOM", onClick = () => {}, disabled = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const tok = getOrgTokens(isDark);

  const tooltipText = disabled 
    ? "Please select or add a process first to upload a BOM." 
    : label;

  return (
    <Tooltip title={tooltipText} placement="top">
      <span>
        <Button
          variant="contained"
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
              return;
            }
            onClick(e);
          }}
          startIcon={<AutoAwesomeOutlinedIcon />}
          disableElevation
          sx={{
            backgroundColor: tok.bg.tabActive,
            color: tok.text.tabActive,
            opacity: disabled ? 0.8 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
            "&:hover": { 
              backgroundColor: tok.bg.tabActive, 
              opacity: disabled ? 0.8 : 0.9 
            },
            borderRadius: tok.radius.icon || 2,
            px: 2,
            height: "40px",
            mr: 1,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "14px",
            fontFamily: tok.font.family,
          }}>
          {label}
        </Button>
      </span>
    </Tooltip>
  );
};
export default UploadBOMButton;
